import { useState } from "react";

type TooltipProps = {
  label: string;
  content: string;
};

export function Tooltip({ label, content }: TooltipProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative inline-flex" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button className="rounded-md border border-border px-3 py-1 text-sm" type="button">
        {label}
      </button>
      {open ? (
        <div className="absolute left-1/2 top-full mt-2 -translate-x-1/2 rounded-md border border-border bg-surface px-2 py-1 text-xs text-text shadow-sm">
          {content}
        </div>
      ) : null}
    </div>
  );
}
